import { render, staticRenderFns } from "./WindowHeaderButton.vue?vue&type=template&id=5908db9c&"
import script from "./WindowHeaderButton.vue?vue&type=script&lang=js&"
export * from "./WindowHeaderButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports